import {
  activateVersionRefreshBanner,
  isProd,
} from "core/model/utils/featureFlags";
import { isPrintMode } from "core/model/utils/urls";
import { Banner } from "ds/ui";
import { Z_INDEX_MAX, dp, sizing } from "ds_legacy/materials/metrics";
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { useTranslations } from "translations";

export function RefreshBanner({ onClick }: { onClick?: AnyFunction }) {
  const translations = useTranslations();
  const { isMobile } = useMedia();
  const isPrint = isPrintMode();

  if (isPrint) return null;

  return (
    <div
      data-testid="refreshBanner"
      style={{
        left: "50%",
        position: "fixed",
        top: sizing(6.5),
        transform: "translateX(-50%)",
        width: sizing(isMobile ? 50 : 64),
        zIndex: Z_INDEX_MAX,
      }}
    >
      <div className="mt-2 w-full">
        <Banner
          actions={[
            {
              id: "refresh",
              label: translations.actions.refresh,
              onPress: onClick ? onClick : () => window.location.reload(),
            },
          ]}
          color="warning"
          message={translations.general.refreshToSeeChanges}
        />
      </div>
    </div>
  );
}

export function RefreshBannerVersionChecker({
  onDismiss,
}: {
  onDismiss: () => void;
}) {
  const translations = useTranslations();
  const isPrint = isPrintMode();

  if (isPrint) return null;

  if (!activateVersionRefreshBanner) {
    return null;
  }

  return (
    <div
      style={{
        bottom: dp(20),
        left: "50%",
        position: "fixed",
        transform: "translateX(-50%)",
        zIndex: Z_INDEX_MAX,
      }}
    >
      <div className="mt-2 w-full">
        <Banner
          actions={[
            {
              id: "refresh",
              label: translations.actions.refresh,
              onPress: () => window.location.reload(),
            },
            ...(!isProd
              ? [
                  {
                    id: "dismiss",
                    label: translations.actions.dismiss,
                    onPress: onDismiss,
                  },
                ]
              : []),
          ]}
          color="primary"
          message={translations.todo.refreshApp}
        />
      </div>
    </div>
  );
}
